var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { isDefined } from "../../lib/is/isDefined.js";
import "../../lib/async/hooks/useAsync.js";
import "markdown-it";
import "react";
import "../../lib/merge/deepMerge.js";
import "react-resize-detector";
const _EventService = class _EventService {
  constructor(params) {
    __publicField(this, "eventChannel");
    __publicField(this, "analyticEvents");
    if (!isDefined(params == null ? void 0 : params.eventChannel)) {
      throw new Error('[EventService] Missing require parameter "eventChannel"');
    }
    const { eventChannel, analyticEvents = [] } = params;
    this.eventChannel = eventChannel;
    this.analyticEvents = analyticEvents;
  }
  static getInstance(params) {
    if (!_EventService.instance) {
      _EventService.instance = new _EventService(params);
    }
    return _EventService.instance;
  }
  /**
   * Отправка аналитического события в глобальный массив `_mtm`.
   * @param event Аналитическое событие для отправки
   */
  static sendAnalyticEvent(event) {
    if (window._mtm) {
      window._mtm.push(event);
    }
  }
  /**
   * Отправка пользовательского события.
   * Также автоматически отправляет подходящее аналитическое событие, если оно существует.
   * @param eventType Тип отправляемого события
   * @param eventPayload Дополнительные данные события
   */
  sendEvent(eventType, eventPayload = {}) {
    if (!isDefined(this.eventChannel)) {
      return;
    }
    const event = new CustomEvent(this.eventChannel, {
      detail: {
        type: eventType,
        ...eventPayload
      }
    });
    document.dispatchEvent(event);
    const matchedAnalytics = this.analyticEvents.filter(({ rule }) => rule(eventType, eventPayload)).map(({ analyticEvent }) => typeof analyticEvent === "function" ? analyticEvent(eventPayload) : analyticEvent);
    matchedAnalytics.forEach(_EventService.sendAnalyticEvent);
  }
};
__publicField(_EventService, "instance");
let EventService = _EventService;
export {
  EventService
};
